module.exports = __webpack_public_path__ + "media/images/new_home/menu-fill-8bb854ac13e556349894afff5f8ed54c.png";